import { useMemo, type ChangeEvent } from 'react';
import { Input, Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

interface Props {
  value?: number | null;
  onChange?: (value: number | null) => void;
  status?: 'error' | 'warning';
  id?: string;
}

// User nhập số ngày → component tự tính và hiển thị "Ngày dự kiến: D/M/YYYY".
// Port pattern từ ancarat-fe DeliveryDaysSelect (digits-only, strip leading
// zeros, empty → null). Tên file giữ "Select" để khỏi đụng import của
// DeliverySection — về bản chất giờ là input số ngày, không phải dropdown.
export function DeliveryDaysSelect({ value, onChange, status, id }: Props) {
  const inputValue = value != null && value > 0 ? String(value) : '';

  const expectedDate = useMemo(() => {
    if (value == null || value <= 0) return null;
    return dayjs().add(value, 'day').format('D/M/YYYY');
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (!raw.trim()) {
      onChange?.(null);
      return;
    }
    if (!/^\d+$/.test(raw)) return;
    // "007" → "7"; "0" → "0" (rule min:1 sẽ reject)
    const normalized = raw.replace(/^0+/, '') || '0';
    const num = parseInt(normalized, 10);
    if (!Number.isNaN(num) && num >= 0) onChange?.(num);
  };

  return (
    <>
      <Input
        id={id}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="Nhập số ngày"
        value={inputValue}
        onChange={handleChange}
        status={status}
      />
      {expectedDate && (
        <Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 2 }}>
          Ngày dự kiến: {expectedDate}
        </Text>
      )}
    </>
  );
}
